module.exports = __webpack_public_path__ + "img/note-remove.7039efd5.svg";